import gql from 'graphql-tag';

export const removeTeamMutation = gql`
	mutation RemoveTeam($id: ID!) {
		removeTeam(id: $id) {
			id
		}
	}
`;
